export default __webpack_public_path__ + "static/media/sample_4.1fc0ed41.png";